import React from "react";
import { Link } from "react-router-dom";
import { imageBaseUrl } from "../../Networking/Api";

const shadowBottom = {
  boxShadow: "0 6px 6px -6px #ccc",
};

function ClinicBookingHeader({
  clinicName,
  logoImg,
  locations,
  selectedLocationId,
  // onLocationChange prop removed since we're not using it anymore
}) {
    console.log("clinicName:", clinicName);
    console.log("locations:", locations);
    console.log("selectedLocationId:", selectedLocationId);
  const selectedLocation = locations.find(
    (loc) => loc.id === selectedLocationId
  );

  return (
    <header className="w-full relative">
      <div
        className="pl-8 pb-6 pt-6 flex items-center px-4 bg-white shadow-sm"
        style={shadowBottom}
      >
        <div className="lg:absolute lg:left-1/2 lg:transform lg:-translate-x-1/2 lg:pl-0 pl-4">
          <Link to="/">
            <img
              width={180}
              height={130}
              src={
                (logoImg && `${imageBaseUrl}/${logoImg}`) ||
                "/clinicPlaceholder.png"
              }
              alt="logo"
              className="p-2"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/clinicPlaceholder.png";
              }}
            />
          </Link>
        </div>
        <div className="ml-auto ">
          <div className="flex items-start space-x-2 mb-2">
            <div className="flex items-start justify-center">
              <span>
                <img src="/loc.png" width="44px" alt="Location Icon" />
              </span>
            </div>
            <div>
              <span className="text-xs text-gray-500">LOCATION</span>
              <div className="text-lg font-semibold text-gray-900">
                {clinicName}
              </div>

              {/* Location dropdown removed - now just displays the selected location */}
              {selectedLocation && (
                <div className="text-sm text-gray-700 mt-1">
                  <p className="font-medium">
                    {selectedLocation.street}, {selectedLocation.city}
                  </p>
                </div>
              )}

              {selectedLocation && (
                <div className="text-sm text-gray-700">
                  <p>
                    {selectedLocation.city}, {selectedLocation.state},{" "}
                    {selectedLocation.country}, {selectedLocation.zipcode}
                  </p>
                  <p className="text-blue-600 cursor-pointer hover:underline">
                    <a href={`tel:${selectedLocation.phone}`}>
                      {selectedLocation.phone}
                    </a>
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default ClinicBookingHeader;